import React from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import { AdminLayoutProvider } from '../contexts/AdminLayoutContext';

const AdminLayout = () => {
  return (
    <AdminLayoutProvider>
      <div className="flex h-screen bg-gray-100">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <AdminHeader />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </AdminLayoutProvider>
  );
};

export default AdminLayout; 